export default __webpack_public_path__ + "static/media/unacast-symbol-white-rgb.2b0f0243.svg";